export default __webpack_public_path__ + "static/media/+-identity4.130b5981.jpg";